@if (approvalType) {
  <mat-card appearance="outlined" class="conditions">
    <mat-card-header class="row space-between">
      <span class="col-10 row">
        <h3 class="title col-4">{{ title }}</h3>
        <span
          *ngTemplateOutlet="addItemButton; context: { class: 'hide-md' }"
        ></span>
      </span>
      <span
        *ngTemplateOutlet="addItemButton; context: { class: 'hide show-md' }"
      ></span>
      <button
        class="col-1 expand-button"
        [ngClass]="shouldExpand ? 'expand' : 'collapse'"
        (click)="shouldExpand = !shouldExpand"
        >
        <mat-icon>expand_more</mat-icon>
      </button>
    </mat-card-header>
    <mat-card-content [ngClass]="shouldExpand ? 'expand' : 'collapse'">
      <app-committee-items
        [projectId]="projectId"
        [approvalType]="approvalType"
        [milestones]="milestones"
        [headerColumns]="headerColumns"
        [isLegalNote]="isLegalNote"
        [isCompleteConditions]="isCompletedConditions"
        [milestone]="milestone"
        [milestoneName]="$safeNavigationMigration(milestone?.name)"
        [milestoneContext]="milestoneId"
        [isConditions]="true"
        [readOnly]="readOnly"
        >
      </app-committee-items>
    </mat-card-content>
  </mat-card>
}

<ng-template #addItemButton let-class="class">
  @if (
    approvalTypeId &&
    permsService.userPerms['COMMITTEEAPPROVALTYPE'][approvalTypeId][
    '_edit'
    ] &&
    !isCompletedConditions
    && !readOnly
    ) {
    <button
      type="button"
      (click)="addItem()"
      class="add-item col-1"
      [ngClass]="class"
      >
      <mat-icon class="add-item">add</mat-icon>
    </button>
  }
</ng-template>
